module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("8GZAT"))).then(() => parcelRequire('jgRpq'));